import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";

import NoPage from "./NoPage";
import Login from "./Login/Login";
import AccessLog from "./AccessLog/AccessLog";

import { EventEmitter } from "../event";
import Navigation from "./Navigation";

import DCM from './DCM/Dcm';
import PatientList from "./patient/PatientList";
import PatientInfo from "./patient/PatientInfo";
import ViewerTabs from "./ViewerTabs";



// The Main component renders one of the three provided
// Routes (provided that one matches). Both the /roster
// and /schedule routes will match any pathname that starts
// with /roster or /schedule. The / route will only match
// when the pathname is exactly the string "/"
const imageId = ['wadouri:https://cdn.virtueanalytics.com/no-cache/0002.DCM',
  'wadouri:https://cdn.virtueanalytics.com/no-cache/0003.DCM',
  'wadouri:wadouri:https://cdn.virtueanalytics.com/no-cache/0004.DCM',
  'wadouri:https://cdn.virtueanalytics.com/no-cache/0009.DCM',
  'wadouri:https://cdn.virtueanalytics.com/no-cache/00012.DCM',
  'wadouri:https://cdn.virtueanalytics.com/no-cache/00015.DCM',
  'wadouri:https://cdn.virtueanalytics.com/no-cache/00020.DCM'
]
 

const stack = {
  imageIds: [imageId],
  currentImageIdIndex: 0
};

function Main(props) {


  return (
   
    <main>
      <BrowserRouter basename="vri">
      {/* <BrowserRouter  > */}
        <Routes>
          <Route path="/" element={<Navigation />}>
            <Route index element={<RequireAuth>
              <PatientList />
            </RequireAuth>} />
            <Route path="Home" element={<RequireAuth><PatientList /></RequireAuth>} />
            <Route path="PatientInfo" element={<RequireAuth><PatientInfo /></RequireAuth>} /> 
            <Route path="ViewerTabs" element={<RequireAuth><ViewerTabs/></RequireAuth>} >
             </Route> 
            <Route path="DCM" element={<DCM stack={{ ...stack }} />} />
            <Route path="AccessLog" element={<RequireAuth><AccessLog /></RequireAuth>} />
            <Route path="*" element={<RequireAuth><NoPage /></RequireAuth>} />
          </Route>
          <Route path="/" element={<Login />}>
            <Route path="Login" element={<Login />} />
          </Route>
          <Route path="*" element={<NoPage />} />
          <Route path="/" element={<NoPage />} />
        </Routes>
      </BrowserRouter>
    </main>
  );
}

export default Main;


function RequireAuth({ children }) { 
  let location = useLocation();
  let [isLogin, setIslogin] = useState(localStorage.getItem("isLogin"));
  EventEmitter.subscribe("loginChanged", (event) => {
    setIslogin(localStorage.getItem("isLogin"));
  })
  if (isLogin !== 'true') {
    return <Navigate to="../login" state={{ from: location }} replace />;
  }
  return children;
}


